import React from 'react';
import AdvancedModal from '@portal/components/AdvancedModal/AdvancedModal';
import { translate } from '@portal/services/i18n';
import { formatPixKey } from '@portal/services/masks';
import { formatDateYearMonthDay } from '@portal/utils/format';

interface PendingPortabilityConfirmationModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  keyValue?: string;
  limitDate?: string;
  onClose: () => void;
  onCancelPortability: () => void;
}

const PendingPortabilityConfirmationModal = ({
  visible,
  setVisible,
  keyValue,
  limitDate,
  onClose,
  onCancelPortability,
}: PendingPortabilityConfirmationModalProps) => (
  <AdvancedModal
    visible={visible}
    title={translate(
      'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_PORTABILITY_CONFIRMATION_MODAL.TITLE'
    )}
    size="small"
    autoHeight
    onClose={() => {
      setVisible(false);
      onClose();
    }}
    actions={[
      {
        label: translate(
          'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_PORTABILITY_CONFIRMATION_MODAL.CLOSE'
        ),
        onClick: () => {
          setVisible(false);
          onClose();
        },
      },
      {
        label: translate(
          'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_PORTABILITY_CONFIRMATION_MODAL.CANCEL'
        ),
        type: 'danger',
        onClick: onCancelPortability,
      },
    ]}
  >
    <p className="pix-portability-modal__text">
      {translate(
        'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_PORTABILITY_CONFIRMATION_MODAL.TEXT_WITHOUT_DETAILS_BEFORE_KEY'
      )}
      <strong>{keyValue ? formatPixKey(keyValue) : ''}</strong>

      {translate(
        'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_PORTABILITY_CONFIRMATION_MODAL.TEXT_WITHOUT_DETAILS_AFTER_KEY'
      )}
    </p>
    {limitDate ? (
      <p className="pix-portability-modal__text">
        {translate(
          'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_PORTABILITY_CONFIRMATION_MODAL.LIMIT_DATE',
          { date: formatDateYearMonthDay(limitDate) ?? '' }
        )}
      </p>
    ) : null}
  </AdvancedModal>
);

export default PendingPortabilityConfirmationModal;
